import { THideItem } from '#/types/hideItem';
import {
  HidenItemsActionType,
  THidenItemsActions,
} from '../actions/hidenItems';

interface IState {
  hidenItems: THideItem[];
}

const initialState: IState = {
  hidenItems: [],
};

const hidenItemsReducer = (
  state = initialState,
  { type, payload }: THidenItemsActions
): IState => {
  switch (type) {
    case HidenItemsActionType.HIDEN_ITEMS_ADD_HIDEN_ITEM:
      return { ...state, hidenItems: [...state.hidenItems, payload] };

    case HidenItemsActionType.HIDEN_ITEMS_REMOVE_HIDEN_ITEM:
      return {
        ...state,
        hidenItems: state.hidenItems.filter(
          (hidenItem) =>
            !(hidenItem.type === payload.type && hidenItem.id === payload.id)
        ),
      };

    case HidenItemsActionType.HIDEN_ITEMS_REMOVE_ALL_HIDEN_ITEMS:
      return {
        ...state,
        hidenItems: state.hidenItems.filter(
          (hidenItem) => hidenItem.type !== payload
        ),
      };

    default:
      return state;
  }
};

export default hidenItemsReducer;
